import React, {useState, useRef} from 'react';
import DateTime from './DateTime';
import { weeksInYear, weekString } from '../../Services/helpers';

const Week = (props) => {
    const [showingAbsolute, setShowingAbsolute] = useState(false);
    const timeout = useRef(null);

    const {relative} = props;

    if (!relative) {
        return <Absolute {...props} />
    }

    const toggle = () => setShowingAbsolute(!showingAbsolute);

    const onMouseLeave = () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => setShowingAbsolute(false), 1000);
    };

    const onMouseEnter = () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => setShowingAbsolute(true), 100);
    }

    return <span onClick={toggle} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {showingAbsolute ?
            <Absolute {...props} /> :
            <Relative {...props} />
        }
    </span>
}

const Absolute = (props) => {
    const {week} = props;
    const parts = week.split('-W');
    const weekNumber = parts[1];

    return <>Week {weekNumber} <span className="text-muted">(w/c <DateTime {...props} />)</span></>
}

const Relative = (props) => {
    const {week} = props;
    const parts = week.split('-W');
    const weekNumber = parseInt(parts[1]);
    const yearNumber = parseInt(parts[0]);

    const thisWeek = weekString();
    const nowParts = thisWeek.split('-W');
    const nowWeek = parseInt(nowParts[1]);
    const nowYear = parseInt(nowParts[0]);

    let weekDifference = weekNumber - nowWeek;
    if (yearNumber > nowYear) {
        weekDifference += weeksInYear(yearNumber);
    }
    if (yearNumber < nowYear) {
        weekDifference -= weeksInYear(yearNumber);
    }

    if (weekDifference === 0) {
        return 'This week';
    }

    if (weekDifference === 1) {
        return 'Next week';
    }

    if (weekDifference === -1) {
        return 'Last week';
    }

    if (weekDifference > 0) {
        return `${weekDifference} weeks from now`;
    }

    return `${-weekDifference} weeks ago`;

}

export default Week;
